module.exports = __webpack_public_path__ + "static/media/emr-icon.bd442490.svg";